import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=9353873c&scoped=true&"
var script = {}
import style0 from "./RightSideBar.vue?vue&type=style&index=0&id=9353873c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9353873c",
  null
  
)

export default component.exports